<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-9" v-if="businesses.length > 1">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
        <div class="col-3.5">
          <div class="form-group has-label">
            <label class="d-flex">{{ $t('state.add_or_remove_state') }}:</label>
            <div class="row mt-2 ml-1">
              <el-button
                :disabled="model.state_count < 11 ? false : true"
                v-tooltip.top-center="{
                  content: `
                      <div>
                        ${$t('state.add_state')}<br>
                        ${
                          model.state_count === 11
                            ? '<small>' +
                              $t('state.cant_add_more_than_10_states') +
                              '</small>'
                            : ''
                        }
                      </div>
                    `,
                  html: true,
                }"
                class="btn-success btn-secondary button-new-tag"
                size="small"
                @click="addState()"
                icon="el-icon-plus"
              >
              </el-button>
              <el-button
                :disabled="model.state_count > minInputs ? false : true"
                v-tooltip.top-center="{
                  content: `
                      <div>
                        ${$t('state.remove_state')}<br>
                        ${
                          model.state_count === minInputs
                            ? '<small>' +
                              $t('state.cant_remove_existing_states') +
                              '</small>'
                            : ''
                        }
                      </div>
                    `,
                  html: true,
                }"
                class="btn-danger btn-secondary button-new-tag"
                size="small"
                @click="minusState()"
                icon="el-icon-minus"
              >
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row py-2 mb-3 shadow-sm">
        <div
          v-for="index in model.state_count"
          :key="index"
          :class="`col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3`"
        >
          <div class="d-flex align-items-center">
            <fg-input
              :min="0"
              :max="10"
              ref="state"
              type="number"
              placeholder="..."
              :requiered="true"
              v-model="model.state[index - 1]"
              @input="validateState(index - 1)"
              class="col-11 px-1 required-state"
              :label="`${$t('state.state_number')} ${
                model.state[index - 1] ? model.state[index - 1] : ''
              }: *`"
              :disabled="model.deleted_at[index - 1] ? true : false"
            >
            </fg-input>
            <div v-if="isDelete() && is_Update">
              <a
                v-tooltip.top-center="
                  getTextTooltipDelete(model.deleted_at[index - 1])
                "
                :class="`${
                  model.deleted_at[index - 1] ? `my_success` : `my_danger`
                } btn-simple custom-margin-actions mt-3`"
                v-model="model.deleted_at[index - 1]"
                ref="deleted_at"
                @click="
                  model.deleted_at[index - 1]
                    ? handleActivate(
                        `${getRoute}/activate`,
                        model.details_ids[index - 1],
                        index - 1
                      )
                    : handleDelete(
                        `${getRoute}`,
                        model.details_ids[index - 1],
                        index - 1
                      )
                "
              >
                <em
                  :class="`fa ${
                    model.deleted_at[index - 1] ? `fa-check-circle` : `fa-times`
                  } custom-size-fa-actions`"
                ></em>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import i18n from 'src/i18n';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinPermissions from 'src/util/mixinPermissions';
import Businesses from 'src/components/Selects/Businesses.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinForm,
    MixinDialog,
    MixinLoading,
    MixinRerender,
    MixinPermissions,
    MixinValidations,
  ],
  components: {
    [Businesses.name]: Businesses,
  },
  data() {
    return {
      status: [],
      minInputs: 1,
      businesses: [],
      is_Update: false,
      businesses_id: [],
      disabledField: false,
      businessesInitial: [],
      model: {
        id: null,
        state: [],
        state_count: 1,
        deleted_at: [],
        details_ids: [],
        businesses_id: [],
        businesses_names: [],
        state_header_id: null,
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          }
          if (this.model.state.length != this.model.state_count) {
            return this.validationInputsRequired('state');
          }
          const stateValues = this.model.state.filter(
            (s) => s !== null && s !== undefined && s !== ''
          );
          const uniqueStates = new Set(stateValues);
          if (stateValues.length !== uniqueStates.size) {
            SweetAlert.danger(this.$t('state.error_duplicate_states'));
            return;
          }
          if (this.is_Update) {
            for (let i = 0; i < this.status.length; i++) {
              if (
                this.status[i] !== this.model.state[i] ||
                this.model.state.length !== this.status.length ||
                this.businesses_id.length !== this.model.businesses_id.length
              ) {
                SweetAlert.confirm(
                  this.$t('common_words.confirm'),
                  this.$t('state.confirm_edit_states')
                ).then((result) => {
                  if (result.value) {
                    this.$emit('addEdit', this.model);
                    return;
                  }
                });
              } else {
                this.$emit('addEdit', this.model);
                return;
              }
            }
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    addState() {
      this.model.state_count++;
    },
    minusState() {
      if (this.model.state_count > 1) this.model.state_count--;
    },
    getTextTooltipDelete(deleted_at) {
      if (deleted_at) return i18n.t('common_words.activate');
      else return i18n.t('common_words.disable');
    },
    validateState(index) {
      let value = this.model.state[index];
      if (value === '' || value === null) return;
      if (value < 0) {
        this.$set(this.model.state, index, 0);
      } else if (value > 10) {
        this.$set(this.model.state, index, 10);
      }
    },
    handleDelete(route, id, index) {
      if (isset(id) && this.isDelete()) {
        const data = {
          route: route,
          id: id,
        };
        SweetAlert.confirm(
          this.$t('common_words.confirm'),
          this.$t('state.confirm_disable_state')
        ).then((result) => {
          if (result.value) {
            Promise.all([Axios.destroyMaster(data)])
              .then(([responseDetail]) => {
                this.$emit('refresh', true);
                const { state_details } = responseDetail.data.data;
                const detail = state_details.filter(
                  (detail) => detail.id == id
                );
                this.$set(this.model.deleted_at, index, detail[0].deleted_at);
              })
              .catch(() => {
                SweetAlert.danger(this.$t('state.user_no_allowed'));
              });
          }
        });
      }
    },
    handleActivate(route, id, index) {
      if (isset(id) && this.isDelete()) {
        const data = {
          route: route,
          id: id,
        };
        SweetAlert.confirm(
          this.$t('common_words.confirm'),
          this.$t('state.confirm_activate_state')
        ).then((result) => {
          if (result.value) {
            Promise.all([Axios.updateMaster(data)])
              .then(([responseDetail]) => {
                this.$emit('refresh', true);
                const { state_details } = responseDetail.data.data;
                const detail = state_details.filter(
                  (detail) => detail.id == id
                );
                this.$set(this.model.deleted_at, index, detail[0].deleted_at);
              })
              .catch(() => {
                SweetAlert.danger(this.$t('state.user_no_allowed'));
              });
          }
        });
      }
    },
  },
  updated() {
    if (
      this.businesses &&
      this.businesses.length === 1 &&
      this.model.businesses_id.length === 0
    ) {
      this.model.businesses_id.push(this.businesses[0].id);
    }
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, state_details } = editForm;
      this.model = {
        ...this.model,
        id,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      this.model.state_count = state_details.length;
      let index = 0;
      state_details.forEach((detail) => {
        this.status.push(detail.state);
        this.model.state.push(detail.state);
        this.model.details_ids.push(detail.id);
        this.model.state_header_id = detail.state_header_id;
        this.$set(this.model.deleted_at, index, detail.deleted_at);
        index++;
      });
      businesses.forEach((bs) => {
        this.businesses_id.push(bs.id);
      });
      sessionStorage.removeItem('editForm');
      this.is_Update = true;
      this.minInputs = this.model.state_count;
    }
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('businesses/normal')])
        .then(([responseBusinesses]) => {
          this.businesses = responseBusinesses.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  computed: {
    getRoute() {
      return 'sigatoka/statedetail';
    },
  },
};
</script>
<style scoped>
.my_danger {
  color: #c63d2f !important;
}
.my_success {
  color: #4f8949 !important;
}
.my_danger:hover {
  cursor: pointer;
}
.my_success:hover {
  cursor: pointer;
}
</style>
